/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minutes: NonNullable<unknown> }} Marketing_Min_ReadInputs */

const en_marketing_min_read = /** @type {(inputs: Marketing_Min_ReadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min read`)
};

const es_marketing_min_read = /** @type {(inputs: Marketing_Min_ReadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min de lectura`)
};

const fr_marketing_min_read = /** @type {(inputs: Marketing_Min_ReadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min de lecture`)
};

/**
* | output |
* | --- |
* | "{minutes} min read" |
*
* @param {Marketing_Min_ReadInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_min_read = /** @type {((inputs: Marketing_Min_ReadInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Min_ReadInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_min_read(inputs)
	if (locale === "es") return es_marketing_min_read(inputs)
	return fr_marketing_min_read(inputs)
});